import CreateCatalogItemSidebar from "@components/catalogs/CatalogOverview/CreateCatalogItemSidebar/CreateCatalogItemSidebar";
import { useAppContextNonNull } from "@contexts/AppContext";
import { socket } from "@contexts/SocketContext";
import ICatalog from "@models/ICatalog";
import ICatalog_ItemUI from "@models/ICatalog_ItemUI";
import IOrder_ItemUI from "@models/IOrder_ItemUI";
import { ButtonGroup, Dropdown } from "react-bootstrap";

type Props = {
    catalogModel: ICatalog;
    item: IOrder_ItemUI;
};

export const OrderEntryLineItemAdminActions = (props: Props) => {
    const { userModel, supplierModel, socket, uiContext } = useAppContextNonNull();

    const cancelEditCatalogItem = () => {
        uiContext.toggleSidebar(false);
        uiContext.setSidebarComponent(null);
    };

    const onEditItem = () => {
        if (props.item.Catalog_Item) {
            const sidebarComponent = (
                <CreateCatalogItemSidebar
                    catalogModel={props.catalogModel}
                    catalogGuid={props.catalogModel.guid}
                    notifyFn={() => {}}
                    socket={socket}
                    userModel={userModel}
                    supplierModel={supplierModel}
                    cancel={cancelEditCatalogItem}
                    showHiddenFeatures={uiContext.showHiddenFeatures}
                    catalog_item={props.item.Catalog_Item as ICatalog_ItemUI}
                    getPriceGroups={true}
                />
            );

            uiContext.setSidebarComponent(sidebarComponent);
            uiContext.toggleSidebar(true);
        } else {
            // Fallback behavior until wired by parent
            window.dispatchEvent(new CustomEvent("ow:missingEditCatalogItem", { detail: props.item }));
        }
    };

    return (
        <div className={"OrderEntryLineItemAdminActions"}>
            <Dropdown as={ButtonGroup} data-bs-theme="dark">
                <Dropdown.Toggle size="sm" variant="primary">
                    Actions
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={onEditItem}>Edit Item</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};
